<div
  id="device-type-table-container"
  class="matp-table-container tw-max-h-[calc(100vh_-_200px)]"
>
  <div class="matp-table-actions-area">
    <div class="matp-table-actions">
      <button
        mat-raised-button
        id="filter-clear-btn"
        class="tw-mr-2"
        (click)="clearFilters()"
      >
        <mat-icon>restart_alt</mat-icon>
        <span>クリア</span>
      </button>
      <button
        mat-raised-button
        id="add-btn"
        color="primary"
        class="tw-mr-2"
        (click)="created.emit()"
      >
        <mat-icon>add</mat-icon>
        <span>新規登録</span>
      </button>
    </div>
  </div>

  <div class="matp-table-area">
    <table
      id="device-type-table"
      class="matp-table"
      mat-table
      matSort
      [matSortActive]="initSortState.active"
      [matSortDirection]="initSortState.direction"
      [dataSource]="dataSource"
      class="matp-table"
    >
      <!-- No -->
      <ng-container matColumnDef="no">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-min">
          <div class="matp-table-header-title">No</div>
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          {{ i + 1 }}
        </td>
      </ng-container>

      <!-- デバイス種類 -->
      <ng-container matColumnDef="deviceTypeId">
        <th mat-header-cell *matHeaderCellDef class="!tw-w-24">
          <div mat-sort-header="displayName" class="matp-table-header-title">
            デバイス種類
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="displayName"
              type="text"
              [(ngModel)]="displayNameKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="displayname-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearDisplayNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.displayName }}
        </td>
      </ng-container>
      <!-- 登録デバイス数 -->
      <ng-container matColumnDef="deviceTypeCount">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">
            登録デバイス数
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.deviceTypeCount }}
        </td>
      </ng-container>
      <!-- 説明 -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">補足/説明</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="description"
              type="text"
              [(ngModel)]="descriptionKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="description-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearDescriptionNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="tw-truncate">{{ element.description }}</div>
        </td>
      </ng-container>
      <!-- 操作 -->
      <ng-container matColumnDef="operation">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-56 tw-max-w-56">
          <div class="matp-table-header-title">操作</div>
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-w-56">
          <div class="tw-flex tw-ml-auto">
            <div class="tw-mx-1">
              <button
                mat-stroked-button
                id="edit-btn"
                color="primary"
                (click)="updated.emit(element)"
              >
                <mat-icon>edit</mat-icon>
                <span>編集</span>
              </button>
            </div>
            <div class="tw-mx-1">
              <button
                mat-stroked-button
                id="delele-btn"
                color="primary"
                (click)="deleted.emit(element.deviceTypeKey)"
              >
                <mat-icon>delete</mat-icon>
                <span>削除</span>
              </button>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    [length]="dataSource.filteredData.length"
    hidePageSize
    showFirstLastButtons
  >
  </mat-paginator>
</div>
